export const primaryColor = "#965ada";
export const secondaryColor = "#bb94e7";
export const inputBackground = "#0c0c0c";
